import { createContextKey } from '@opentelemetry/api';

const SENTRY_TRACE_HEADER = 'sentry-trace';

const SENTRY_BAGGAGE_HEADER = 'baggage';

const SENTRY_DYNAMIC_SAMPLING_CONTEXT_KEY = createContextKey('SENTRY_DYNAMIC_SAMPLING_CONTEXT_KEY');

const SENTRY_TRACE_PARENT_CONTEXT_KEY = createContextKey('SENTRY_TRACE_PARENT_CONTEXT_KEY');

export { SENTRY_BAGGAGE_HEADER, SENTRY_DYNAMIC_SAMPLING_CONTEXT_KEY, SENTRY_TRACE_HEADER, SENTRY_TRACE_PARENT_CONTEXT_KEY };
//# sourceMappingURL=constants.js.map
